<template>
  <div class="list-container">
    <template v-for="(item, index) in offersData">
      <div :key="index" class="list-item-content " @click="toOfferDetail(item)">
        <div class="flex-start">
          <div class="logo-content">
           <img class="company-logo" :src="item.company_logo || 'https://files.wondercv.com/icon/Artboard.png'" alt="">
          </div>
          <div class="offer-info flex-column" >
            <div class="offer-title-content flex-between">
              <span class="title">{{ item.company_name }}</span>
              <div class="collection-outside"  @click.stop="debounce(() => {campusOfferCollect(item)}, 300)">
                <div class="flex-center collection" :class="{ 'job-is-liked': item.job_is_liked }">
                  {{ item.job_is_liked | jobLikeFilter }}
                </div>
              </div>
            </div>
            <div class="flex-start offer-profession-address">
              <span class="flex-start" v-if="item.category">{{ item.category }}</span>
              <span class="flex-start">{{ item.city_names | cityFilter }}</span>
            </div>
          </div>

          <!-- <div class="flex-start offer-status">
            <div class="status-btn flex-center recommend-btn" v-if="item.can_recommend">{{ item.can_recommend | recommendFilter }}</div>
            <div class="status-btn flex-center" v-if="item.display_time">{{ item.display_time }}</div>
            <div class="status-btn flex-center" v-if="item.status">{{ item.status }}</div>
          </div> -->
        </div>
        <div class="offer-time" v-if="item.comp_recruit_schedule.slice(1,4).filter(item=> !!item.value).length > 0">
          <div class="offer-time-list" v-for="(offer,sindex) in item.comp_recruit_schedule.slice(1,4).filter(item=> !!item.value && !item.value.includes('截止'))" :key="sindex + 'a'">
            <div class="offer-time-label">{{offer | filterType}}</div>
            <div class="offer-time-info">{{year}}年{{offer.value.split('-')[0] | filterTime}}</div>
            <div class="line" v-if="(sindex + 1 != item.comp_recruit_schedule.slice(1,4).filter(item=> !!item.value).length)"> </div>
          </div>
        </div>
        <!-- <div v-else-if="!!item.end_time || !!item.start_time" class="offer-time">
          <div class="offer-time-list">
            <div class="offer-time-label">{{!!item.end_time ? '截止时间' : '开始时间'}}</div>
            <div class="offer-time-info" v-if="!!item.end_time">{{item.end_time | filterFormateTime}}</div>
            <div class="offer-time-info" v-else-if="!!item.start_time">{{item.start_time | filterFormateTime}}></div>
          </div>
        </div> -->
        <div v-else class="offer-time">
          <div class="offer-time-list">
            <div class="offer-time-label">发布时间</div>
            <div class="offer-time-info">{{ moment(item.created_at).format('YYYY-MM-DD')}}</div>
          </div>
        </div>
        <div class="offer-bottom">
          <div class="offer-bottom-left" v-if="item.can_recommend">
            {{item.internal_recommend_count > 3 ? item.internal_recommend_count : 3}}名用户可帮你内推
          </div>
          <div class="offer-bottom-right" v-if="item.display_time">
            {{item.display_time}}
          </div>
          <div class="offer-bottom-right" v-if="item.status">
            {{item.status}}
          </div>
          <div class="offer-bottom-right" v-if="!item.display_time && !item.status && !item.can_recommend">
            职位热招中
          </div>
        </div>
      </div>
      <div v-if="tag === 'recommend' && index === 5 && adInfo" class="ad-info-box">
        <img :src="adInfo.image" alt="" @click.stop="handleClickToDetail">
      </div>

    </template>

  </div>
</template>

<script>
  import {envMixin, loginMixin} from "../../../assets/js/mixin/global";
  import {campusOfferMixin} from "../../../assets/js/mixin/jobs";
  import {userMixin} from "../../../assets/js/mixin/user";
  import {componentsMixin} from "../../../assets/js/mixin/components";
  import moment from 'moment'
  export default {
    name: 'job-list-campus-offers',
    mixins: [ envMixin, campusOfferMixin, loginMixin, userMixin, componentsMixin ],
    props: {
      offersData: {
        type: Array,
        default: () => []
      },
      adInfo: {
        type: [Object, Array],
        default: null
      },
      tag: {
        type: String,
        default: 'recommend'
      }
    },
    data() {
      return {
        moment,
        year: new Date().getFullYear()
      }
    },
    mounted() {

    },
    filters:{
      filterTime(val) {
        return val.replace(/截止/g,"").replace(/开始/g,"");
      },
      filterType(val) {
        if( val.value.split('-').length == 2 ) {
          return val.type + "开始"
        } else {
          let temp = val.value.includes('开始') ? '开始' : '截止'
          return val.type + temp
        }
      }
    },
    computed: {},
    watch: {},
    components: {},
    methods: {
      toOfferDetail(item) {
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/campusOffersDetail/campusOffersDetail?campusOfferToken=${item.token}`
          })
        } else {
          this.$router.push(`/jobs/campus/offers/${item.token}`)
        }
      },
      handleClickToDetail(){
        if (this.isWxMini) {
          this.$wechat.miniProgram.navigateTo({
            url: `/pages/freeUrl/freeUrl?url=${this.adInfo.link}`
          })
        } else {
          window.location.href = this.adInfo.link
        }
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../../../assets/scss/global/variable';
  @import '../../../assets/scss/global/mixin';
  .collection-outside {
    padding: 10px;
    position: absolute;
    right: -10px;
    top: -10px;
  }
  .offer-time {
    padding:12px 0px 0px 51px;
    .offer-time-list{
      display: flex;
      align-items: center;
      position: relative;
      z-index: 9;
      margin-bottom: 4px;
      .offer-time-label{
        color: #606060;
        font-size: 11px;
        width: 62px;
        height: 22px;
        margin-right: 10px;
        background-image: url('https://files.wondercv.com/m/message.png');
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .line{
        position: absolute;
        z-index: 1;
        width: 1px;
        border: 1px solid #ECECEC;
        height: 12px;
        left: 30px;
        top: 26px;
      }
    }
    .offer-time-info{
      display: flex;
      align-items: center;
      width: 191px;
      height: 30px;
      border-radius: 4px;
      background-color: #F9F9F9;
      color: #606060;
      font-size: 13px;
      box-sizing: border-box;
      padding-left: 16px;
    }
  }
  .offer-bottom {
    border-top: 1px dashed #ECECEC;
    display: flex;
    margin-top: 12px;
    padding-top: 11px;
    .offer-bottom-left{
      width: 128px;
      height: 22px;
      background-color: #FFF8EB;
      border-radius: 12px;
      margin-right: 5px;
      color: #D59960;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: $font-size-small;
    }
    .offer-bottom-right{
      padding: 5px 10px;
      background-color: #F9F9F9;
      border-radius: 12px;
      color: #9C9C9C;
      margin-right: 6px;
      font-size: $font-size-small;
    }
  }
  .list-container {
    padding: 12px;
    background-color: #F9F9F9;
    .list-item-content {
      background-color: #fff;
      box-shadow: 0px 1px 10px 0px rgba(3, 47, 129, 0.01);
      border-radius: 6px;
      padding: 16px;
      padding-bottom: 12px;
      margin-bottom: 10px;
      .logo-content {
        .company-logo {
          width: 46px;
          height: 46px;
          border-radius: 6px;
          margin-right: 10px;
          object-fit: contain;
          border: 1px solid #f4f4f4;
          border-radius: 6px;
        }
      }
      .offer-info {
        flex: 1;
        .offer-title-content {
          margin-bottom: 6px;
          position: relative;
          .title {
            color: $color-title;
            font-size: $font-size-medium-x;
            font-weight: 500;
            @include ellipsis(216px);
          }
          .collection {
            width: 50px;
            height: 20px;
            border-radius: 14px;
            border: 1px solid $color-theme;
            color: $color-theme;
            font-weight: 500;
            font-size: 12px;
          }
          .job-is-liked {
            color: #BCBCBC;
            border: 1px solid #ECECEC;
          }
        }
        .offer-profession-address {
          margin-bottom: 6px;
          span {
            color: #9c9c9c;
            font-size: $font-size-medium;
            line-height: 14px;
            &::after {
              content: '';
              width: 1px;
              height: 10px;
              background-color: #ECECEC;
              margin: 0 6px;
            }
            &:last-child::after {
              display: none;
            }
          }
        }
        .offer-status {
          .status-btn {
            padding: 3px 4px;
            border-radius: 2px;
            border: 1px solid #CFCFCF;
            margin-right: 6px;
            font-size: 10px;
            color: #9C9C9C;
          }
          .recommend-btn {
            border-color: $color-theme;
            color: $color-theme;
          }
        }
      }
    }
    .ad-info-box{
      height: 90px;
      margin-bottom: 10px;
      & > img{
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 8px;
      }
    }
  }
</style>
